module.exports = __webpack_public_path__ + "media/images/emblems/Carouge-coat_of_arms-18017e975526c3b244c81b59079c4c22.svg";